import React, {useState, useEffect} from "react";
import Color from "../../Components/Colors/Color";
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import '../Styles/ResetPassword.css'
import { handlePasswordReset } from "../Controller/LoginController";

const ResetPassword = () => {

    const navigate = useNavigate();

    const [password, setPassword] = useState({
        new: "",
        confirm: ""
    })

    const [passwordVisiblity, setPasswordVisibility] = useState({
        new: false,
        confirm: false
    })

    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [snackbarFlag, setSnackbarFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        const email = localStorage.getItem('email');
        const otp = sessionStorage.getItem('otp');
        if(!email || !otp){
            missingInput();
        }
    }, [])


    useEffect(() => {
        if(!openSnackbar && snackbarFlag){
            setSnackbarFlag(false);
            navigate('/admin/forgot-password');
        }

        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin')
        }

    }, [openSnackbar && success, openSnackbar && snackbarFlag])

    const missingInput = () => {
        setSeveritySnackbar("error");
        setMessageSnackbar("Please provide an email and an otp");
        setOpenSnackbar(true);
        setSnackbarDuration(2000);
        setSnackbarFlag(true);
    }

    const decryptOtp = (encryptedOtp) => {
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const shifted = encryptedOtp.split('').map(char => {
            let shiftedIndex = (alphabet.indexOf(char) - 7) % 25; // Reverse Caesar's cipher shift of 3
            return alphabet[shiftedIndex];
        });

        const originalNumbers = shifted.map(char => alphabet.indexOf(char)); // Convert letter back to number (1-indexed)
        const originalDigits = originalNumbers.map(num => num - 3); // Divide each number by 3 to get original digits

        return originalDigits.join('');
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if(password.new !== password.confirm){
            setSeveritySnackbar("error");
            setMessageSnackbar("Passwords do not match");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
            return;
        }

        const email = localStorage.getItem('email');
        const otp = sessionStorage.getItem('otp');

        if(!email || !otp){
            missingInput();
            return;
        }

        const originalOtp = decryptOtp(otp);
        console.log(originalOtp);

        const resetForm = {
            "otp": originalOtp,
            "newPassword": password.new
        }

        try{
            setLoading(true);

            const response = await handlePasswordReset(email, resetForm);

            const status = response?.status;

            console.log(response);

            if (status === 200) {

                setSeveritySnackbar("success");
                setMessageSnackbar("Password Reset Successful");
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(true);
                sessionStorage.removeItem('otp');
                localStorage.removeItem("email")
                console.log('Here');
                
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured, please try again");
                setSuccess(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
        } finally{
            setLoading(false);
        }
    }

    return(
        <>
            <div className="reset-pass-container" style={{backgroundColor: Color.secondaryBackground}}>
                <div className='reset-pass-logo-container small-screen'>
                        <img src='/Images/logo.png' alt='opc-logo' className='reset-pass-logo' />
                    </div>
                <div className='reset-pass-card-container' style={{backgroundColor: Color.primaryBackground}}>
                    <div className='reset-pass-logo-container'>
                        <img src='/Images/logo.png' alt='opc-logo' className='reset-pass-logo' />
                    </div>
                    <div className='reset-pass-header-container'>
                        <h3 className='reset-pass-header'>
                            Reset Password
                        </h3>
                    </div>

                    <form className='reset-pass-form-container' onSubmit={handleResetPassword}>
                        <div className='reset-pass-label-input-container'>
                            <label htmlFor='new-password' className='reset-pass-label'>
                               New Password
                            </label>
                            <input
                                type={passwordVisiblity.new ? 'text' : 'password'}
                                id='new-password'
                                className='reset-pass-input'
                                placeholder='********'
                                value={password.new}
                                onChange={e => setPassword({...password, new: e.target.value})}
                                style={{color: Color.thirdText}}
                                required
                                />
                            <span className={`reset-pass-eye-password ${passwordVisiblity.new ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye' }`} onClick={() => setPasswordVisibility(prevState => ({...prevState, new: !passwordVisiblity.new}))} style={{color: Color.thirdText}}></span>
                        </div>
                        <div className='reset-pass-label-input-container'>
                            <label htmlFor='confirm-password' className='reset-pass-label'>
                               Confirm Password
                            </label>
                            <input
                                type={passwordVisiblity.confirm ? 'text' : 'password'}
                                id='confirm-password'
                                className='reset-pass-input'
                                placeholder='********'
                                value={password.confirm}
                                onChange={e => setPassword({...password, confirm: e.target.value})}
                                style={{color: Color.thirdText}}
                                required
                                />
                            <span className={`reset-pass-eye-password ${passwordVisiblity.confirm ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye' }`} onClick={() => setPasswordVisibility(prevState => ({...prevState, confirm: !passwordVisiblity.confirm}))} style={{color: Color.thirdText}}></span>
                        </div>
                        <div className='reset-pass-btn-container'>
                            <button className='reset-pass-btn'>Reset</button>
                        </div>
                    </form>

                </div>
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>
            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default ResetPassword;